import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { QRCodeCanvas } from 'qrcode.react';

/**
 * Renders a QR code to a PNG data URL using the same qrcode.react library
 * as worksheet distribution (QRShareModal / QRCodeDisplay).
 */
export const generateQrDataUrl = (value: string, size = 300): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!value) {
      reject(new Error('Cannot generate QR code for empty value'));
      return;
    }

    const host = document.createElement('div');
    host.style.cssText = 'position:fixed;left:-9999px;top:0;pointer-events:none;';
    document.body.appendChild(host);

    const root = createRoot(host);
    const cleanup = (): void => {
      root.unmount();
      host.remove();
    };

    root.render(
      createElement(QRCodeCanvas, {
        value,
        size,
        level: 'M',
        marginSize: 1,
      })
    );

    // Two frames so React can commit the canvas before we read it
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          const canvas = host.querySelector('canvas');
          if (!canvas) {
            cleanup();
            reject(new Error('QR canvas was not rendered'));
            return;
          }
          resolve(canvas.toDataURL('image/png'));
        } catch (error) {
          reject(error);
        } finally {
          cleanup();
        }
      });
    });
  });
};
